"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _dictDetail = _interopRequireDefault(require("@/api/system/dictDetail"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {
  id: null,
  label: null,
  value: null,
  unit: null,
  dictSort: 999
};
var _default = {
  components: {
    pagination: _Pagination.default,
    rrOperation: _RR.default,
    udOperation: _UD.default
  },
  cruds: function cruds() {
    return [(0, _crud.default)({
      title: '字典详情',
      url: 'api/dictDetail',
      query: {
        dictName: ''
      },
      sort: ['dictSort,asc', 'id,desc'],
      crudMethod: _objectSpread({}, _dictDetail.default),
      optShow: {
        add: true,
        edit: true,
        del: true,
        reset: false
      },
      queryOnPresenterCreated: false
    })];
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(function () {
    return Object.assign({
      dict: {
        id: this.dictId
      }
    }, defaultForm);
  })],
  data: function data() {
    return {
      dictId: null,
      rules: {
        label: [{
          required: true,
          message: '请输入字典标签',
          trigger: 'blur'
        }],
        value: [{
          required: true,
          message: '请输入字典值',
          trigger: 'blur'
        }],
        dictSort: [{
          required: true,
          message: '请输入序号',
          trigger: 'blur',
          type: 'number'
        }]
      },
      permission: {
        add: ['admin', 'dict:add'],
        edit: ['admin', 'dict:edit'],
        del: ['admin', 'dict:del']
      }
    };
  }
};
exports.default = _default;